import PropTypes from 'prop-types';
import CommentTextArea from 'apps/profile/components/interactions/comment-textarea';
import { useInteractionFormContext } from 'apps/interactions/form/context/interaction-form-context';
import { useRef } from 'react';

const CommentTextField = ({ field = {}, form = {}, contactId, onClose = () => {}, isPinned }) => {
  const { name } = field;
  const { hasInteractionWrites, interactionStandardFieldsConfig } = useInteractionFormContext();
  const { values, handleSubmit, setFieldValue, isValid } = form;
  const maxLength = interactionStandardFieldsConfig?.text?.max_length;

  const commentBoxRef = useRef(null);

  /**
   * The CommentTextArea component does not simply update a single field for the interaction.
   * Instead, it updates the entire interaction object.
   * As such, we have to handle it differently than other fields.
   * the comment text area has a new button. Clicking this button updates the fields on the form and then immediately submits the form.
   */
  const handleCommentSave = async (interaction) => {
    // Overwrite existing values with the new interaction object returned by the CommentTextArea
    // the false flag is to disable form validation when we set the values
    // handleSubmit() validates, so we do not need to run validate back to back (doing so prevents submit from firing)
    await setFieldValue('pinned', interaction?.pinned, false);
    await setFieldValue('contact_mention', interaction?.contact_mention, false);
    await setFieldValue('user_mention', interaction?.user_mention, false);
    await setFieldValue(name, interaction?.text);

    handleSubmit();
    if (isValid) onClose();
  };

  return (
    <CommentTextArea
      ref={commentBoxRef}
      className="interaction-form--gt-comment"
      open={true}
      disabled={!contactId}
      comment={values || {}}
      onSave={handleCommentSave}
      onCancel={onClose}
      {...(hasInteractionWrites ? { maxLength } : {})}
      disableCheckbox={isPinned} // if a user is creating a pinned comment, this will be "true" and unchangeable
      testId="comment-text-field"
    />
  );
};

CommentTextField.propTypes = {
  field: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
  }),
  form: PropTypes.shape({
    setFieldValue: PropTypes.func.isRequired,
    setFieldTouched: PropTypes.func,
    errors: PropTypes.object,
    touched: PropTypes.object,
    values: PropTypes.object,
    dirty: PropTypes.bool,
    isValid: PropTypes.bool,
    handleSubmit: PropTypes.func,
    setValues: PropTypes.func,
    setErrors: PropTypes.func,
  }),
  contactId: PropTypes.number,
  onClose: PropTypes.func,
  isPinned: PropTypes.bool,
};

export default CommentTextField;
